import React, { Fragment, useMemo } from "react";
import { navigate } from "gatsby";
import {
  CellProps,
  Column,
  useExpanded,
  useFilters,
  usePagination,
  useSortBy,
  useTable
} from "react-table";
import fp from "lodash/fp";
import Spacer from "./common/Spacer";
import styled, { css } from "styled-components";
// import axios from "axios";
import Table from "./common/Table";
import Link from "@components/Link";
// import config from "../configs/awsConfig";
// import { useUsersState } from "../contexts/UserAuthContext";
import { Dialog, DialogOverlay, DialogContent } from "@reach/dialog";
import "@reach/dialog/styles.css";

const Wrapper = styled.div`
  //border: 1px solid red;
  tbody {
    tr {
      border: 1px solid LightGray;
    }
    td.action {
      //border: 3px solid red;
      padding: 7px 10px;
    }
  }
  h3 {
    font-size: 1.4rem;
    font-weight: bold;
  }
`;

const DialogInnerWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;
  p {
    grid-column: 1 / 3;
  }
  button {
    ${p =>
      p.warning &&
      css`
        grid-column: 1 / 3;
      `}
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!"
  },
  number: {
    range: "${label} must be between ${min} and ${max}"
  }
};

const getRemain = record => {
  return !fp.isNull(record) ? record.capacity - record.current : 0;
};

const getTableLabel = id => {
  const labels = {
    date: "날짜:",
    time: "시간:",
    capacity: "정원:",
    apply: "신청자:"
  };
  return labels[id];
};

const EventsTable = ({ events, requests, date, loading, header }) => {
  const [showDialog, setShowDialog] = React.useState(false);
  const [showWarning, setShowWarning] = React.useState(false);
  const [step, setStep] = React.useState(1);
  const [request, setRequest] = React.useState({});
  const buttonRef = React.useRef();
  const open = () => setShowDialog(true);
  const close = () => setShowDialog(false);

  // Column definition
  const columns = useMemo(
    () => [
      {
        Header: "날짜",
        accessor: "date" // accessor is the "key" in the data
      },
      {
        Header: "시간",
        accessor: "time" // accessor is the "key" in the data
      },
      {
        Header: "정원",
        accessor: "capacity" // accessor is the "key" in the data
      }
      // {
      //   Header: "신청자",
      //   accessor: "apply"
      // }
    ],
    []
  );

  const getRequests = eventId =>
    requests?.filter(request => request.eventId === eventId);

  // Data
  const data = useMemo(() => {
    return fp.flow(
      fp.filter(event => event.date === date),
      fp.map(event => fp.assign(event, { requests: getRequests(event.id) }))
    )(events);
    // events.filter(event => event.date === date)
  }, [date]);
  const sortableColumns = ["capacity"];

  const tableInstance = useTable(
    { columns, data },
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    visibleColumns,
    pageOptions,
    page,
    state: { expanded, pageIndex, pageSize },
    gotoPage,
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage
  } = tableInstance;

  return (
    <Wrapper>
      <h3>{header}</h3>
      <Spacer axis={"vertical"} size={10} />
      <Table visible={true} width={"1fr 1fr 1fr 1fr 1fr 1fr"}>
        <thead>
          {headerGroups.map(headerGroup => (
            // eslint-disable-next-line react/jsx-key
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => {
                const props = sortableColumns.includes(column.id)
                  ? {
                      ...column.getSortByToggleProps(),
                      className: column.id
                    }
                  : { className: column.id };
                return (
                  // eslint-disable-next-line react/jsx-key
                  <th {...column.getHeaderProps(props)}>
                    <div>
                      {
                        // Render the header
                        column.render("Header")
                      }
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>

                      {column.Filter ? column.render("Filter") : null}
                    </div>
                  </th>
                );
              })}
              <th>신청자</th>
              <th>신청</th>
              <th>관리자</th>
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page
            .filter(item => item.values.date === date)
            .map((row, i) => {
              // Prepare the row for display
              const { id, date, time, capacity, requests } = row.original;
              prepareRow(row);
              return (
                // eslint-disable-next-line react/jsx-key
                <Fragment key={i} {...row.getRowProps()}>
                  <Dialog
                    isOpen={showDialog}
                    initialFocusRef={buttonRef}
                    // onDismiss={close}
                  >
                    {!showWarning && step === 1 && (
                      <DialogInnerWrapper warning={showWarning}>
                        <p>
                          정토사회문화회관 둘러보기 프로그램은
                          정토회원(전법모둠, 회원그룹, 천일결사자그룹원,
                          불교대학/경전대학 재학생)에 한하여 신청이 가능합니다.
                          <br />
                          <br /> 정토회원이 맞으신가요?
                        </p>
                        <button
                          ref={buttonRef}
                          onClick={() => {
                            setStep(2);
                          }}
                        >
                          예
                        </button>
                        <button
                          onClick={() => {
                            setShowWarning(true);
                          }}
                        >
                          아니요
                        </button>
                      </DialogInnerWrapper>
                    )}
                    {!showWarning && step === 2 && (
                      <DialogInnerWrapper warning={true}>
                        <p>
                          신청은 진행일 3일 전 13시까지 가능합니다. 정상 신청이
                          된 경우 진행일 하루 전 19시 이전까지 안내 문자가 발송
                          됩니다.
                        </p>
                        <button
                          ref={buttonRef}
                          onClick={() => {
                            navigate("/form", {
                              state: {
                                eventId: request.id,
                                date: request.date,
                                time: request.time
                              }
                            });
                          }}
                        >
                          확인
                        </button>
                        {/*<button*/}
                        {/*  onClick={() => {*/}
                        {/*    setShowWarning(true);*/}
                        {/*  }}*/}
                        {/*>*/}
                        {/*  아니요*/}
                        {/*</button>*/}
                      </DialogInnerWrapper>
                    )}
                    {showWarning && step === 1 && (
                      <DialogInnerWrapper warning={showWarning}>
                        <p>
                          정토사회문화회관 둘러보기는 정토회원 대상으로 진행되는
                          프로그램입니다. 많은 관심 감사합니다.
                        </p>
                        <button
                          onClick={() => {
                            setShowWarning(false);
                            setStep(1);
                            close();
                          }}
                        >
                          확인
                        </button>
                      </DialogInnerWrapper>
                    )}
                    {/*{showWarning && step === 2 && (*/}
                    {/*  <DialogInnerWrapper warning={showWarning}>*/}
                    {/*    <p>*/}
                    {/*      정토사회문화회관은 수행공간이자 서울공동체의*/}
                    {/*      생활공간으로 백신접종완료 후 14일 경과자에 한하여*/}
                    {/*      출입이 가능합니다. 백신접종 후 이용하여 주시기*/}
                    {/*      바랍니다.*/}
                    {/*    </p>*/}
                    {/*    <button*/}
                    {/*      onClick={() => {*/}
                    {/*        setShowWarning(false);*/}
                    {/*        setStep(1);*/}
                    {/*        close();*/}
                    {/*      }}*/}
                    {/*    >*/}
                    {/*      확인*/}
                    {/*    </button>*/}
                    {/*  </DialogInnerWrapper>*/}
                    {/*)}*/}
                  </Dialog>
                  <tr>
                    {row.cells.map(cell => {
                      return (
                        // eslint-disable-next-line react/jsx-key
                        <td
                          {...cell.getCellProps({
                            className: cell.column.id
                          })}
                          data-th={getTableLabel(cell.column.id)}
                        >
                          {cell.render("Cell")}
                          {cell.column.id === "capacity" && "명"}
                        </td>
                      );
                    })}
                    <td data-th={"신청자:"}>
                      {requests.length}명&nbsp;
                      {requests.length > 0 && (
                        <Link
                          className={"admin"}
                          to={"/requests"}
                          state={{ requests: requests, eventId: id }}
                          // state={{ eventId: id }}
                        >
                          목록보기
                        </Link>
                      )}
                    </td>
                    <td className={"action"} data-th={"신청:"}>
                      {capacity > requests.length ? (
                        <button
                          onClick={() => {
                            setRequest({ id, date, time });
                            open();
                          }}
                        >
                          신청하기
                        </button>
                      ) : (
                        "마감"
                      )}
                    </td>
                    <td className={"admin"} data-th={"관리자:"}>
                      <Link
                        to={"/form"}
                        state={{ eventId: id, date: date, time: time }}
                      >
                        {/*수정*/}
                      </Link>
                    </td>
                  </tr>
                </Fragment>
              );
            })}
        </tbody>
      </Table>
    </Wrapper>
  );
};

export default EventsTable;
